import { Component, OnInit} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PackingOrderService } from '../../services/packing-order.service';
import { Location } from '@angular/common';
import { PackPackingOrderStep } from '../../models/entities/pack-packing-order-step';
 

@Component({
    selector: 'pack-packing-order-step-list-mobile',
    templateUrl: './pack-packing-order-step-list-mobile.component.html',
    styleUrls: ['./pack-packing-order-step-list-mobile.component.scss']
})

export class PackPackingOrderStepListMobileComponent implements OnInit {

  packPackingOrderSteps   : PackPackingOrderStep[] = [];
  packCode                : string;

  constructor(
    protected packingOrderService : PackingOrderService,
    protected toastr              : ToastrService,
    protected location            : Location
    ) {
  }


  //------------------------------------------------------------------------------------------------------------------------
    ngOnInit(): void {
    }
  //------------------------------------------------------------------------------------------------------------------------
  

    //---------------------------------------------------------------------------------------------------------------
    loadData() {
      this.packingOrderService.packPackingOrderStepsGet(this.packCode).then(result => {
          this.packPackingOrderSteps = result;
      })
    }
    //---------------------------------------------------------------------------------------------------------------
        



  //------------------------------------------------------------------------------------------------------------------------
    close(){
      this.location.back();
    }
  //------------------------------------------------------------------------------------------------------------------------
}
